import React from 'react';

const PlainTable = ({ 
  children, 
  className = '',
  ...props 
}) => {
  return (
    <table className={`w-full hairline ${className}`} {...props}>
      {children}
    </table>
  );
};

const PlainTableRow = ({ children, className = '', onClick, ...props }) => {
  const baseClasses = 'last:border-b-0 hairline-b';
  const clickableClasses = onClick ? 'cursor-pointer hover:bg-neutral-50 transition-colors duration-120' : '';
  const classes = `${baseClasses} ${clickableClasses} ${className}`;

  return (
    <tr className={classes} onClick={onClick} {...props}>
      {children}
    </tr>
  );
};

const PlainTableCell = ({ children, className = '', header = false, ...props }) => {
  const baseClasses = 'hairline-r px-4 py-2 text-sm text-neutral-900';
  const headerClasses = header ? 'font-mono uppercase tracking-wider font-medium' : '';
  const classes = `${baseClasses} ${headerClasses} ${className}`;

  const Component = header ? 'th' : 'td';

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

PlainTable.Row = PlainTableRow;
PlainTable.Cell = PlainTableCell;

export default PlainTable; 